<template>
  <div id="occurrence-column-chart">
    <apexchart :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

function sort(array, prop) {
  return array.sort((a, b) => {
    if (a[prop] < b[prop]) { return -1; }
    if (a[prop] > b[prop]) { return 1; }
    return 0; // Se são iguais
  });
}

export default {
  components: { apexchart: VueApexCharts },
  data: () => ({ }),
  props: ['occurrences', 'target', 'filename'],
  computed: {
    data() {
      if(!this.occurrences || this.occurrences.length == 0 || !this.target || this.target.length == 0) {
        return []
      }
      
      // Se o target for statusDescription, separamos por status
      if(this.target.name === 'statusDescription') {
        const reduced = this.occurrences
          .map(o => ({ 
            name: o.processName,
            status: o.overdue ? 'Atrasado' : 'No Prazo'
          }))
          .reduce((acc, item) => {
            const found = acc?.find(o => o.name === item.name);
            
            if(found) { 
              if(item.status === 'Atrasado') {
                found.atrasado = (found.atrasado || 0) + 1;
              } else {
                found.noPrazo = (found.noPrazo || 0) + 1;
              }
            } else { 
              acc.push({ 
                name: item.name, 
                atrasado: item.status === 'Atrasado' ? 1 : 0,
                noPrazo: item.status === 'No Prazo' ? 1 : 0
              }) 
            }
            
            return acc;
          }, [])

        return sort(reduced, 'name')
      }
      
      // Comportamento padrão para outros targets
      const reduced = this.occurrences
        .map(o => ({ name: o[this.target.name] }))
        .reduce((acc, item) => {
          const found = acc?.find(o => o.name === item.name);
          
          if(found) { found.data += 1; } 
          else { acc.push({ name: item.name, data: 1 }) }
          
          return acc;
        }, [])

      return sort(reduced, 'name')
    },
    series() {
      if(this.target.name === 'statusDescription') {
        return [
          {
            name: 'No Prazo',
            data: this.data.map(x => x.noPrazo || 0)
          },
          {
            name: 'Atrasado',
            data: this.data.map(x => x.atrasado || 0)
          }
        ]
      }
      
      return [{
        name: 'Ocorrências',
        data: this.data.map(x => x.data)
      }]
    },
    chartOptions() {
      const self = this;
      return {
        colors:['#00909F', '#FF751B', '#4C999A', '#FF8E3C', '#7BA687', '#89FFDB'],
        chart: {
          type: 'bar',
          height: 350,
          toolbar: {
            show: true,
            tools: {
              download: true
            },
            export: {
              csv: { filename: self.filename },
              png: { filename: self.filename },
              svg: { filename: self.filename },
            }
          },
          stacked: false
        },
        plotOptions: {
          bar: {
            columnWidth: this.target.name === 'statusDescription' ? '45%' : '90%',
            borderRadius: 5,
            borderRadiusApplication: 'end',
            dataLabels: {
              position: 'center',
            },
          },
        },
        dataLabels: { enabled: false },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: this.data.map(x => x.name),
        },
        yaxis: {
          title: {
            text: this.label
          },
          labels: {
            formatter: function (val) {
              return Math.round(val);
            }
          }
        },
        fill: { opacity: 1 },
        tooltip: {
          y: {
            formatter: function (value) { return `${value}` }
          }
        }
      }
    },
    label() {
      return this.$t('quantidade')
    },
  }
}
</script>